import React from 'react';

import { Box, CardMedia, Typography } from '@mui/material';

import styled from '@emotion/styled';

import { Offer } from '../../../../graphql/API';
import Icons from '../../../../themes/icons';

type Props = {
  offer: Offer;
  selected?: boolean;
  onSelection?: () => void;
};

export const OfferCard: React.FC<Props> = ({
  offer: { title, picture },
  selected = false,
  onSelection,
}) => {
  return (
    <Container selected={selected} onClick={onSelection}>
      <CardMedia
        component={'img'}
        src={String(picture?.medium)}
        width={'100%'}
        height={175}
        loading='lazy'
        onError={(e) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-expect-error
          e.target.src = String(data?.picture?.small);
        }}
        sx={{ objectFit: 'cover' }}
      />
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontSize: '15px',
          px: 1.5,
          pt: 1.5,
          pb: 4,
          fontWeight: selected ? 500 : 400,
        }}
      >
        {title}
      </Typography>
      {selected && (
        <Box sx={{ position: 'absolute', right: '18px', top: '10px' }}>
          <Icons.SelectedTickIcon />
        </Box>
      )}
    </Container>
  );
};

const Container = styled.div<{ selected?: boolean }>`
  background-color: #fff;
  border-radius: 12px;
  border: ${(props) => (props.selected ? '2px solid #765BC6' : '1px solid #efeeee')};

  position: relative;
  overflow: hidden;
  cursor: pointer;
`;
